import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "buttons" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pencil" }, null, -1)
const _hoisted_3 = { class: "application" }
const _hoisted_4 = ["textContent", "onClick"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "columns" }
const _hoisted_7 = { class: "col half" }

import { computed, markRaw, onMounted } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store";
import { Application } from "@/models/application";
import { Note } from "@/models/note";
import ApplicationForm from "./ApplicationForm.vue";
import { DrawerMutations } from "@/stores/drawer.store";
import { useRouter } from "vue-router";
import { Shortcut } from "@/models/shortcut";
import Filter from "../common/Filter.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Applications',
  setup(__props) {

const store = useStore();
const router = useRouter();
const applications = computed<Application[]>(
  () => store.getters.filteredApplications
);
const notes = computed<Note[]>(() => store.state.notes);
const shortcuts = computed<Shortcut[]>(() => store.state.shortcuts);

onMounted(() => {
  store.dispatch(Actions.GetApplications);
  store.dispatch(Actions.GetNotes);
  store.dispatch(Actions.GetShortcuts);
});

const getNotes = (ids: number[] = []) =>
  notes.value.filter((n: Note) => ids.includes(n.id));

const getShortcuts = (id: number) =>
  shortcuts.value.filter((s: Shortcut) => s.application_id === id);

const addApplication = () => {
  store.commit(DrawerMutations.OpenDrawer, {
    drawer: markRaw(ApplicationForm)
  });
};

const navigate = (id: number) => {
  router.push(`/application/${id}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Filter),
      _createElementVNode("button", {
        type: "button",
        class: "option",
        onClick: addApplication
      }, [
        _hoisted_2,
        _createTextVNode(" Add application ")
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applications.value, (application) => {
      return (_openBlock(), _createElementBlock("section", _hoisted_3, [
        _createElementVNode("h2", {
          textContent: _toDisplayString(application.name),
          onClick: ($event: any) => (navigate(application.id))
        }, null, 8, _hoisted_4),
        _createElementVNode("p", {
          textContent: _toDisplayString(application.description)
        }, null, 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, _toDisplayString((application.modes || []).length) + " Modes", 1),
            _createElementVNode("li", null, _toDisplayString(getNotes(application.features).length) + " Features", 1),
            _createElementVNode("li", null, _toDisplayString(getShortcuts(application.id).length) + " Shortcuts", 1)
          ])
        ])
      ]))
    }), 256))
  ], 64))
}
}

})